<div nz-row class="flex-span3 flex-span21 search-container" [ngClass]="{'collapse': collapse, 'expand': !collapse, 'search-cpn-container': searchCpn}" id="searchContainer">
    <!-- 搜索按钮 -->
    <div nz-col searchResponsiveUi class="search-btn-area" style="margin-left: auto;">
        <ng-content select="[searchBtn]"></ng-content>
        <a (click)="toggleCollapse()" *ngIf="isWrapping && !searchCpn" class="collapse-btn">
          {{(collapse ? "Common.Expand" : "Common.Collapse") | translate}}
          <span nz-icon [nzType]="collapse ? 'down' : 'up'" ></span>
        </a>
        <a (click)="toggleCollapse()" class="collapse-cpn-btn collapse-btn" *ngIf="isWrapping && searchCpn">
          {{(collapse ? "Common.Expand" : "Common.Collapse") | translate}}
          <span nz-icon [nzType]="collapse ? 'down' : 'up'" ></span>
        </a>
    </div>

    <!-- 搜索条件: 组件(封装了2个搜索条件), 只支持含有一个搜索组件 -->
    <nz-col *ngIf="searchCpn" class="search-cpn ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-12 ant-col-xl-16 ant-col-xxl-16">
      <ng-content select="[searchCpn]"></ng-content>
    </nz-col>

    <!-- 搜索条件 -->
    <ng-content select="[query]"></ng-content>
</div>

